// extracted by mini-css-extract-plugin
export default {"amountInfo":"RegularPalletAmountInfo_amountInfo__Wxub5"};